import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";
import { testLocator } from "@/lib/helpers/test-locator";

import { getAutomationDataAttr } from "../../utils/automationUtils";
import Input from "../../components/UI/Input";

import "./styles.scss";

export const ConsentEmail = ({ children, className, color, consentEvent, type, ...props }) => (
  <label
    className={createClassNameString(["ConsentEmail--container", className])}
    {...getAutomationDataAttr("consent-to-receive-emails-checkbox")}
    {...testLocator("marketingEmailCheckbox")}
  >
    <Input
      className="ConsentEmail--checkbox"
      name="email-consent"
      onClick={() => consentEvent()}
      type="checkbox"
    />
    <span className="ConsentToTreatment--text">
      I consent to receive marketing and reminder emails from aptihealth. I understand that my
      consent to such emails is not required to use aptihealth’s services and that I may revoke my
      consent at any time.
    </span>
  </label>
);

ConsentEmail.defaultProps = {
  consentEvent: () => {},
};
